import Vue from 'vue';
import eventNotifier from '../utils/event-notifier';

Vue.use({
  install(_Vue) {
    _Vue.prototype.$eventNotifier = eventNotifier;
  },
});
